import Category from '@/models/Category';
import { Family } from '@/models/Family';
import * as Yup from 'yup';

export const schema = Yup.object().shape({
    name: Yup.string()
        .required()
        .min(1),
    author: Yup.string().required(),
    path: Yup.string().required(),
});

export const formInitialState = {
    mainImage: undefined,
    name: '',
    description: undefined,
    author: undefined,
    path: '',
    category: { name: '', id: undefined } as Category,
    category2: { name: '', id: undefined } as Category,
    tags: [],
    workload: undefined,
    families: [] as Family[],
};

export const formErrors = {
    nameError: false,
    authorError: false,
    categoryError: false,
    tagsError: false,
    pathError: false,
};
